import React, { useState } from 'react'
import '../../src/App.scss'
import { Typography } from 'antd'

const FAQS = () => {
    const [openIndex, setOpenIndex] = useState(0)

    const toggleAnswer = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "What is Pip Grid?",
            answer: "Pip Grid is an advanced forex trading bot that automates trading processes, helping you make informed decisions and maximize your trading profits in the forex market."
        },
        {
            question: "Can I use the bot on multiple accounts?",
            answer: "No, each file is valid for one trading account only. If you wish to use the bot on multiple accounts, you will need to purchase additional files."
        }, 
        {
            question: "How do I install and set up Pip Grid?",
            answer: "After purchasing, you will receive an email with download instructions and a comprehensive guide to help you install and set up the bot on your preferred trading platform."
        },
        {
            question: "Can I customize the bot's trading parameters?",
            answer: "No, Pip Grid is designed with predefined settings to ensure optimal performance. Customization of trading parameters such as risk levels, stop-loss, and take-profit is not available."
        },
        {
            question: "Is Customer Support Available?",
            answer: "Absolutely. Our customer support team is here to assist you 247. Feel free to reach at +971 566082283 if you have any questions or need assistance."
        },
        {
            question: "Can I See Results Before Investing?",
            answer: "Yes, you can explore live performance proofs on our website and see the results yourself before making any commitments."
        },
        {
            question: "Do I Need Trading Experience To Use Pip Pilots?",
            answer: "Not at all. Pipgrid Bot is designed for both novices and seasoned traders. You don’t need any prior trading knowledge or experience to benefit from our automated solutions."
        },
        {
            question: "Is the $1000 a one-time payment?",
            answer: "Yes, the final payment amount is $1000. No extra charges, no upsells."
        },
        {
            question: "How long does it take after the payment to get product access?",
            answer: "You will get access to the product within 24 Hours"
        },
        {
            question: "Is there a free trial?",
            answer: "No, there is no free trial for our bot. For reviewing our history, you can see our Live Portfolios."
        },
        {
            question: "What is the minimum deposit?",
            answer: "The minimum deposit amount is $2000 "
        },
        {
            question: "What is the maximum deposit?",
            answer: "There is no cap for deposit. You can deposit as much as you would like."
        },
    ];

    return (
        <div>
            {faqs.map((faq, index) => (
                <div key={index} className={`p-5 faqs-block ${openIndex === index ? 'open' : ''}`} onClick={() => toggleAnswer(index)}>
                    <Typography className='question'>
                        Q. {faq.question}
                    </Typography>
                    <div className={`answer-wrapper ${openIndex === index ? 'show' : ''}`}>
                        <Typography className='answer'>
                            A.&nbsp; {faq.answer}
                        </Typography>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default FAQS